/**
 * 配置加载工具
 * 用于从 public/config.json 加载网站配置
 */

let configCache = null;

/**
 * 获取配置
 * @returns {Promise<Object>} 配置对象
 */
export async function getConfig() {
  if (configCache) {
    return configCache;
  }

  try {
    const response = await fetch('/config.json?t=' + Date.now());
    if (!response.ok) {
      throw new Error('Failed to load config');
    }
    configCache = await response.json();
    return configCache;
  } catch (error) {
    console.error('Error loading config:', error);
    // 返回默认配置
    return getDefaultConfig();
  }
}

/**
 * 获取默认配置（当配置文件加载失败时使用）
 */
function getDefaultConfig() {
  return {
    site: {
      name: "文信软件",
      title: "文信软件科技（广州）有限公司",
      copyright: "2017-2023 © 【版权所有】 文信软件科技（广州）有限公司"
    },
    nav: {
      logo: "/img/logo.png",
      menu: []
    },
    carousel: {
      interval: 3000,
      items: []
    },
    services: {
      title: "服务领域",
      description: "",
      items: []
    },
    cases: {
      title: "经典案例",
      items: []
    },
    about: {
      title: "关于文信",
      content: ""
    },
    news: {
      title: "公司动态",
      subtitle: "COMPANY NEWS",
      description: "关注文信最新活动与行业交流",
      items: []
    },
    whyChoose: {
      title: "为什么选择文信",
      left: [],
      right: []
    },
    customers: {
      energy: { left: [], right: [] },
      others: { list: [] }
    },
    footer: {
      contact: {},
      wechat: []
    }
  };
}

/**
 * 清除配置缓存
 * 用于强制重新加载配置
 */
export function clearConfigCache() {
  configCache = null;
}

/**
 * 获取指定路径的配置值
 * @param {string} path - 配置路径，如 'site.name'
 * @returns {Promise<any>} 配置值
 */
export async function getConfigValue(path) {
  const config = await getConfig();
  const keys = path.split('.');
  let value = config;

  for (const key of keys) {
    if (value && typeof value === 'object') {
      value = value[key];
    } else {
      return null;
    }
  }

  return value;
}
